<template>
  <div>
    <section class="section team dark" :id="section" ref="hero">
      <ul ref="team" :options="options" class="team-list hs list-unstyled">
        <li class="team-member" :class="{ active: selectedItem && item.name == selectedItem.name }" v-for="(item, index) in items" :key="index">
          <div class="article animated fadeInRightShort" @click="toggleModal(index)">
            <div class="article__title">
              <h3 class="article__name">{{ item.name }}</h3>
              <h6 class="article__position">{{ item.position }}</h6>
            </div>
            <div class="article__preview-image">
              <img :src="item.src" :alt="item.name" />
            </div>
          </div>
        </li>
      </ul>
    </section>

    <!-- Modal -->
    <div
      @keyup.esc="closeModal"
      @keyup.right="next"
      @keyup.left="previous"
      class="modal fade team-modal"
      id="teamModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="teamModalLabel"
      aria-hidden="true"
    >
      <div class="modal-header">
        <div class="modal-nav">
          <button @click="previous()" title="Previous" class="btn btn-circle btn-info is-borderless modal-prev">
            <i class="icon-chevron-left"></i>
          </button>
          <button @click="next()" title="Next" class="btn btn-circle btn-info is-borderless modal-next">
            <i class="icon-chevron-right"></i>
          </button>
        </div>

        <button
          type="button"
          title="Close"
          class="btn btn-circle btn-info is-borderless btn-close"
          data-dismiss="modal"
          @click="closeModal()"
          on
          aria-label="Close"
        >
          <i class="icon-close"></i>
        </button>
      </div>
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <transition name="team-fade">
            <div class="modal-body section light-gradient" v-if="showModalData">
              <div class="container">
                <div class="row no-gutters align-items-center">
                  <div class="col-12 col-md-8 offset-md-2 col-xl-7 offset-xl-0 col-xxl-5 offset-xxl-0">
                    <div class="article">
                      <div class="article__title">
                        <h2 class="article__name">{{ this.selectedItem.fullname }}</h2>
                        <h6 class="article__position">{{ this.selectedItem.position }}</h6>
                        <div class="article__body">
                          <div class="description">
                            <p v-for="(p, index) in selectedItem.bio" :key="index">{{ p }}</p>
                          </div>
                          <ul class="list-unstyled social">
                            <li>
                              <a
                                :href="'https://www.linkedin.com/in/' + this.selectedItem.linkedin"
                                title="Open LinkedIn profile"
                                class="btn btn-link"
                                target="_blank"
                                >LinkedIn</a
                              >
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-sm-6 offset-sm-3 col-xl-4 offset-xl-1 col-xxl-6">
                    <div class="article__preview-image">
                      <img :src="selectedItem.white" :alt="selectedItem.name" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </transition>
        </div>
      </div>
    </div>
    <!-- /modal -->
  </div>
</template>

<script>
import { currentSection } from './../../mixins/changeSection';
import { setTimeout } from 'timers';

export default {
  name: 'hero-carousel',
  mixins: [currentSection],
  props: ['title', 'subtitle', 'section', 'image'],
  data() {
    return {
      options: {},
      items: [
        {
          src: 'assets/img/team/black/carlos.png',
          link: 'carlos-torres',
          white: 'assets/img/team/white/carlos.png',
          name: 'Carlos Torres',
          fullname: 'Carlos Trêpa Torres',
          position: 'Founder & CEO',
          bio: [
            'I am very fortunate to be able to combine my passion for business and technology, and desire to engage in entrepreneurial activities, by building a company which focuses on my passion and is driven by a purpose I support full heartedly.',
            'Being able to feed my beliefs and vision of a future unknown yet inevitable and with unprecedented impact, provides a constant flow of energy and excitement. Each day is unique and presents a new challenge or opportunity – the environment in which I excel the most.',
            'Every day I share the same joy going to work in the morning as I do going home in the evening. I feel proud of our team just as I feel proud of my family. I have the perfect balance of work and life, where both complement each other.',
            '“Do what you love, and you’ll never work a day in your life.”'
          ],
          linkedin: 'carlostrepatorres'
        },
        {
          src: 'assets/img/team/black/atte.png',
          link: 'atte-anema',
          white: 'assets/img/team/white/atte.png',
          name: 'Atte Anema',
          fullname: 'Atte Anema',
          position: 'Co-founder & CFO',
          bio: [
            'I have always enjoyed helping others succeed. Whether through mentoring or direct involvement, contributing to people or initiatives that try to change the world gets me out of bed in the morning. As Chief Financial Officer I make sure our organization is as accountable as possible, so the rest of the team can focus on maximizing their impact without distractions.',
            'I believe in building businesses the right way. This includes providing the right environment for individuals to thrive. One thing I love most about our company is witnessing the growth of all team members. In order to change the world, we have to start with our own people, offering them the opportunity to grow beyond what even they thought was possible.',
            'I have a passion for people with a passion and love it when musicians can transfer theirs to the audience. Therefore, you can regularly find me at concerts and festivals enjoying live music.',
            '“Being a good company is an end in itself.”'
          ],
          linkedin: 'atteanema'
        },
        {
          src: 'assets/img/team/black/lina.png',
          link: 'lina-karvelyte',
          white: 'assets/img/team/white/lina.png',
          name: 'Lina Karvelyte',
          fullname: 'Lina Karvelyte',
          position: 'Head of Legal & Operations',
          bio: [
            'I have always been passionate about helping organizations and people to succeed. Whether I work for a multinational or a pro bono project, I am always driven, engaged and mindful of the big picture. Having spent my career in FTSE100 companies, I decided to leverage my experience and promote new ways of managing legal issues.',
            'In my view, legal profession should evolve and become more accessible, affordable and efficient. Technologies have already shaped our workplace and lives, but legal sector is resistant to these changes.',
            'I stand against inefficiencies and bureaucracy, and I am determined to be part of the solution which only emerging technologies and collaboration can offer.'
          ],
          linkedin: 'lina-karvelyte'
        },

        {
          src: 'assets/img/team/black/fabio.png',
          link: 'fabio-franco',
          white: 'assets/img/team/white/fabio.png',
          name: 'Fábio Franco',
          fullname: 'Fábio Franco',
          position: 'CTO',
          bio: [
            'I have always wanted to create a positive impact in the world on different levels since I was a child. As I grew I fell in love with technology and it reached a point when I realized this passion could be put to good use to fulfill a lifetime’s dream.',
            'During my career it has always been a challenge to find purpose beyond business, but today my passion and curiosity for technology is helping me find new ways to create impact. I can finally say I can use my skillsets to leave my mark on the world.',
            '"Our heads are round so our thoughts can change direction."'
          ],
          linkedin: 'fabio-s-franco'
        },
        {
          src: 'assets/img/team/black/junior.png',
          link: 'junior-carvalho',
          white: 'assets/img/team/white/junior.png',
          name: 'Junior Carvalho',
          fullname: 'Junior Carvalho',
          position: 'Senior DevOps Engineer',
          bio: [
            'I believe that automation of repetitive tasks empowers people to do more meaningful work with their time. I’m always looking for the most efficient way to complete a challenge, so whenever I identify a pattern on what I’m doing, I start looking for ways to automate it. This mindset is a result of the way I see the world. Being self-taught led me to explore more and think outside the box, always looking for the best tool to solve a problem, even if I need to spend more effort to learn about a topic.',
            'As a very curious person, whenever I have something new to learn, regardless of being something personal or professional, I like to grasp every aspect of it. This curiosity has led me to naturally merge the world of software development and infrastructure. As a DevOps engineer, I can combine my passion for solving complex problems, automating tasks, and desire for continuous learning.',
            'This search for efficiency helps me find a perfect balance between life and work. I can manage my time with peace of mind knowing that I can deliver at work whilst enjoy quality time with family and friends.',
            '“The greatest enemy of knowledge is not ignorance, it is the illusion of knowledge.”'
          ],
          linkedin: 'carvalhojunior'
        },
        {
          src: 'assets/img/team/black/alberto.png',
          link: 'alberto-molero',
          white: 'assets/img/team/white/alberto.png',
          name: 'Alberto Molero',
          fullname: 'Alberto Molero',
          position: 'Senior Software Engineer',
          bio: [
            'I am an innovative software engineer, an adventurous world traveler and a fun dad. I wear many hats in life and pride myself for having a positive outlook and can-do attitude.',
            'A problem solver in nature, I am strangely obsessed with finding the perfect solution to any given problem, be it in my professional or personal life.',
            'As a world traveler, I have explored almost a hundred countries and lived in three different continents. What I found during my travels is that people around the world are facing the same problems, both in life and in business, which can easily be solved with technology. This is what drives me to continuously innovate and excel in software development.',
            '“I choose a lazy person to do a hard job. Because a lazy person will find an easy way to do it.”'
          ],
          linkedin: 'albertomolero'
        },
        {
          src: 'assets/img/team/black/jethro.png',
          link: 'jethro-sloan',
          white: 'assets/img/team/white/jethro.png',
          name: 'Jethro Sloan',
          fullname: 'Jethro Sloan',
          position: 'Solutions Architect',
          bio: [
            'I have a strong passion and drive for problem solving and software engineering, which is the perfect fit for the industry and company. I always focus on simple solutions for complex problems to achieve longevity and maintainability in all the work I produce.',
            'My drive stems from dedication to not only the mind but the body. Investing time in working on both aspects has given me great focus, hunger and desire, and a robust work ethic. Possessing these tools provide me with a strong platform to succeed. I am very passionate about life and my work. My personality reflects this by always bringing humour and positivity to the table.',
            'Wearing my heart on my sleeve I feel every failure and success. I believe in always putting the team first, together we can achieve anything!',
            '“Perfection is not the absence of change but the ability to change without impact.”'
          ],
          linkedin: 'jethro-david-kerr-sloan'
        },
        {
          src: 'assets/img/team/black/jeff.png',
          link: 'jeff-silva',
          white: 'assets/img/team/white/jeff.png',
          name: 'Jeff Silva',
          fullname: 'Jeff Silva',
          position: 'Head of UX/UI Design',
          bio: [
            'I am self-taught. I think and relate the beauty of how the world can look like tomorrow without losing touch with today’s problems. Delivering impressive experiences by working on every detail for what people really need. I see through the simplicity of life and minimal environments which allows me to bring the right and best solution for any digital product, as well as in my personal life.',
            'My motivation is beyond life patterns and working time. It’s a passion that flows through my mind, my heart and the universe I want to discover in every moment. As a gaming and futuristic world enthusiastic, I’m always learning and trying new tools and possibilities.',
            'My inspiration comes from movies, video-games, playing the bass, making drawings and random places I like to explore and people I’m eager to meet.',
            '“Let’s bring simplicity back”'
          ],
          linkedin: 'jeffersonpsilva'
        } //,
        // {
        //   src: 'assets/img/team/black/laurentiu.png',
        //   link: 'laurentiu-cozma',
        //   white: 'assets/img/team/white/laurentiu.png',
        //   name: 'Laurentiu Cozma',
        //   fullname: 'Laurentiu Cozma',
        //   position: 'Senior Quality Assurance',
        //   bio: [
        //     'I’m a passionate software tester with a highly curious and critical mindset, keen on learning and experimenting every day. I have been very curious since I was a child, dismantling everything that fell into my hands so I could see what was inside, what made it tick. Therefore, I think my current profession is a natural evolution from that period of my life.',
        //     'My daily job is an extension of my interests in technology and computer science, and some of my personal skills help me become better every day. I like tinkering with software and hardware, so naturally I do the same things at home when managing my home server, home network, and even designing my home electrical system when it was needed.',
        //     'I’m your local handyman, so I will be able to design a test plan, define a test approach, create a test script and even build my dog a kennel when I couldn’t find one that suited its needs.',
        //     '“It’s supposed to be automatic, but actually you have to push this button.”'
        //   ],
        //   linkedin: 'laurentiucozma'
        // },
        // {
        //   src: 'assets/img/team/black/miriam.png',
        //   link: 'miriam-maan',
        //   white: 'assets/img/team/white/miriam.png',
        //   name: 'Miriam Maan',
        //   fullname: 'Miriam Maan',
        //   position: 'Product Owner',
        //   bio: [
        //     'My personal goal is to positively shape the influence of technology. I believe humans are here to create and that new technologies play an important role in enabling people to add value to the community. Old methods and systems are poorly suited to the transformed and interconnected communities we live in today.',
        //     'I love to work in an area where technology and business come together and drive innovation. I want to challenge existing beliefs about the world, think outside the box and enable people to achieve their full potential.',
        //     'My interdisciplinary neuroscience and data-oriented background, combined with my passion for working with new technologies and project-management skills, enable me to take ownership of our core product, Element(s). I help establish a shared vision across the company and lead the conceptual and technical development of new initiatives and projects.',
        //     '"Create the things you wish existed."'
        //   ],
        //   linkedin: 'miriam-maan'
        // }
      ],
      selectedIndex: null,
      showModalData: false
    };
  },
  methods: {
    toggleModal(selected) {
      this.showModalData = true;
      this.selectedIndex = selected;
      $('#teamModal').modal('toggle');
    },
    closeModal() {
      this.$router.push({ name: 'home', params: { link: null } });
      this.showModalData = false;
      this.selectedIndex = null;
    },
    next() {
      this.showModalData = false;
      const currIndex = this.selectedIndex;
      this.selectedIndex = (currIndex + 1) % this.items.length;
      setTimeout(() => {
        this.showModalData = true;
      }, 1000);
    },
    previous() {
      this.showModalData = false;
      const currIndex = this.selectedIndex;
      this.selectedIndex = currIndex == 0 ? this.items.length - 1 : (currIndex - 1) % this.items.length;

      setTimeout(() => {
        this.showModalData = true;
      }, 1000);
    }
  },
  computed: {
    selectedItem() {
      if (this.selectedIndex == null) {
        return {};
      }
      const item = this.items[this.selectedIndex];
      this.$router.push({ name: 'home', params: { link: item.link } });
      //this.$route.params.link = item.link;
      return item;
    }
  },
  mounted() {
    console.log();
    const self = this;
    if (this.$route.params.link) {
      const index = this.items.findIndex(n => n.link.toLowerCase() == this.$route.params.link.toLowerCase());
      if (index >= 0) {
        this.toggleModal(index);
      }
    }
    self.$refs.team.addEventListener('mousewheel', function(e) {
      self.$refs.team.scrollLeft -= e.wheelDelta;
      e.preventDefault();
    });
  }
};
</script>
